<template>
    <div>
        <footer id="footer" class="dark border-top-0">
			<div id="copyrights">
				<div class="container text-center text-uppercase">
					Sistema de gerenciamento
				</div>
			</div><!-- #copyrights end -->
		</footer>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
    footer{
        background: none !important;
       #copyrights{
           padding: 15px 0 !important;
        }
    }
</style>